import { useState } from 'react'
import Card from '@mui/joy/Card'
import Box from '@mui/joy/Box'
import FormControl from '@mui/joy/FormControl'
import FormLabel from '@mui/joy/FormLabel'
import Textarea from '@mui/joy/Textarea'
import Typography from '@mui/joy/Typography'
import Input from '@mui/joy/Input'
import Button from '@mui/joy/Button'

export const UserProfileForm = ({ onSubmit }) => {
    const [name, setName] = useState(null)
    const [description, setDescription] = useState(null)

    return (
        <Card sx={{ width: 400 }} variant="outlined" color="neutral">
            <Box sx={{ m: 2 }}>
                <FormControl sx={{ display: 'flex', gap: 3 }}>
                    <div>
                        <FormLabel>Company Name</FormLabel>
                        <Input
                            placeholder="Cool Company, LLC."
                            onChange={(e) => setName(e.target.value)}
                        />
                    </div>
                    <FormControl>
                        <FormLabel>What does your company do?</FormLabel>
                        <Textarea
                            disabled={false}
                            placeholder={'A little bit about your company...'}
                            minRows={8}
                            maxRows={10}
                            onChange={(e) => setDescription(e.target.value)}
                        />
                    </FormControl>
                    <Button
                        variant="solid"
                        color="primary"
                        type="submit"
                        disabled={name === null || description === null}
                        onClick={() => onSubmit({ name, description })}
                    >
                        Next
                    </Button>
                </FormControl>
            </Box>
        </Card>
    )
}
